import { render, staticRenderFns } from "./SocialSeriesHeader.vue?vue&type=template&id=1c563b9e&"
import script from "./SocialSeriesHeader.vue?vue&type=script&lang=js&"
export * from "./SocialSeriesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c563b9e')) {
      api.createRecord('1c563b9e', component.options)
    } else {
      api.reload('1c563b9e', component.options)
    }
    module.hot.accept("./SocialSeriesHeader.vue?vue&type=template&id=1c563b9e&", function () {
      api.rerender('1c563b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialSeriesHeader.vue"
export default component.exports